import React from 'react';
import { Home, ArrowLeft } from 'lucide-react';
import { Link, useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-screen-sm px-4">
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 text-center">
        <p className="text-[6rem] font-bold leading-none text-primary">404</p>
        <h1 className="text-3xl font-semibold">Page Not Found</h1>
        <p className="text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-4">
          <Button variant="outline" onClick={() => navigate({ to: '/' })}>
            <ArrowLeft />
            Go Back
          </Button>
          <Button asChild>
            <Link to="/">
              <Home />
              Go Home
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
